import React from 'react'
//TUTORIAL -> https://www.taniarascia.com/using-context-api-in-react/

export const initialState = {cart:null,orders:null};
function unionSameProduct(cart){
  let listofitem=[]
  cart[0].item.forEach(element => {
    if(!listofitem.find(item => item.size === element.size && item.item.id === element.item.id)){
      listofitem.push(element)
    }else{
      listofitem.find(item => item.size === element.size && item.item.id === element.item.id).quantity = listofitem.find(item => item.size === element.size && item.item.id === element.item.id).quantity  + element.quantity
    }
  });

  cart[0].item=listofitem
  return cart
}
export const reducer = (state, action) => {
  switch (action.type) {
    case "INIT":
      return {
        ...state, cart: action.payload
      };
    case "SET_ORDERS":
      return {
        ...state, orders:action.payload
      }
      case "UPDATE_ORDER":
        let listOrder = state.orders;
        var foundIndex = listOrder.findIndex(x => x.id == action.payload.id);
        listOrder[foundIndex] = action.payload
        return {
          ...state, orders:listOrder
        }
    case "ADD_NEW_ORDER":
      let listOrder2 = state.orders;
      listOrder2.push(action.payload)
      return {...state, orders:listOrder2}
    case "ADD":
        return {
          ...state, cart:action.payload 
        };
    case "REMOVE":
        return {
            ...state, cart:action.payload
        };
    case "CHECKOUT_OK":
      return{
        ...state, cart:[]
      }
    default:
      return state;
  }
};

const CartContext = React.createContext(initialState);

export const CartProvider = CartContext.Provider
export const CartConsumer = CartContext.Consumer
export default CartContext